<div 
    [style.width.px]="originalWidth" 
    [style.height.px]="originalHeight" 
    [style.background]="backgroundColor"
    style="position:relative;border:none"
    >
    <div [style]="feedsContentStyle" style="position:absolute;z-index:0;">
        <ng-container #feedsContainer></ng-container>
    </div>
</div>